"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("../index"));
var version = "v1";
var _default = exports["default"] = {
  getServices: function getServices(id, subfamily) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _index["default"].get("/".concat(version, "/vendors/ground-transfer/").concat(subfamily, "/").concat(id, "/availabilities"), {
      params: params
    });
  },
  getEstimations: function getEstimations(id, subfamily) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _index["default"].get("/".concat(version, "/vendors/ground-transfer/").concat(subfamily, "/").concat(id, "/estimations"), {
      params: params
    });
  },
  makeReservation: function makeReservation(id, subfamily) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _index["default"].post("/".concat(version, "/vendors/ground-transfer/").concat(subfamily, "/").concat(id, "/reservations"), params);
  },
  cancel: function cancel(id, subfamily, requestId, _ref) {
    var charge = _ref.charge;
    var url = "/".concat(version, "/vendors/ground-transfer/").concat(subfamily, "/").concat(id, "/reservations/").concat(requestId);
    if (charge) url += "?charge=".concat(charge);
    return _index["default"]["delete"](url);
  }
};